
import appdata from '@/mixins/appdata'
import statecities from '@/mixins/defaults/statecities'

const addresses = {
  mixins: [ appdata, statecities ],
  data: () => ({
    addressValid: false,
    editingAddressId: -1,
    editingAddress: {}
  }),
  methods: {
    newAddress () {
      const address = {
        cep: '',
        address: '',
        num: '',
        state: this.get_options.default_state,
        city: this.get_options.default_city
      }
      this.editingAddressId = 0
      this.editingAddress = Object.assign({}, address)
    },
    defaultAddress (address) {
      const addresses = this.addresses
      const index_ = addresses.indexOf(address)
      addresses.splice(index_, 1)
      addresses.push(address)
    },
    editAddress (address) {
      this.closeEditAddress()
      const addresses = this.addresses.slice().reverse()
      const index_ = addresses.indexOf(address)
      this.editingAddressId = index_ + 1
      this.editingAddress = Object.assign({}, address)
    },
    saveAddress ({ index, address }) {
      this.$nextTick(function () {
        const addresses = this.addresses
        if (index === 0) {
          addresses.push(address)
        } else {
          addresses[index] = this.editingAddress
        }
        this.editingAddressId = -1
        this.editingAddress = []
      })
    },
    closeEditAddress () {
      this.editingAddressId = -1
      this.editingAddress = []
    },
    deleteAddress (address) {
      this.$store.dispatch('setOverlay', true)
      const addresses = this.addresses
      const index_ = addresses.indexOf(address)
      this.$root.$dialog.confirm({
        text: `${this.lang.customers.dialog.deleteAddressConfirm} ${address.address}?`,
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) addresses.splice(index_, 1)
      })
    }
  }
}

export default addresses
